import styled from "styled-components";
import { TopicElement } from "shared/types";

interface Props {
  data: TopicElement;
}

export default function Link({ data }: Props) {
  return (
    <>
      <Title>{data.title}</Title>
      <Url>{data.siteUrl}</Url>
    </>
  );
}

const Title = styled.a`
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.41px;
  line-height: 24px;
  color: #3c424a;
  text-decoration: underline;
`;

const Url = styled.a`
  font-weight: 300;
  font-size: 10px;
  letter-spacing: 0.29px;
  line-height: 10px;
  color: #cf73b2;
  word-break: break-all;
  margin-top: 12px;
`;
